/**
 * SitePick front — お気に入りストア（docs/06 §1 / §8）
 *
 * localStorage キー `sitepick_favorites` に「商品 post ID の配列のみ」を保存する。
 * 追加順を保持。極端な件数は上限で防御する（UI 上の制限ではない）。
 */

import { createIdStore } from "./id-store.js";

const DEFAULT_MAX = 200;

const max =
  window.SITEPICK &&
  window.SITEPICK.limits &&
  Number.isInteger(window.SITEPICK.limits.favoritesMax)
    ? window.SITEPICK.limits.favoritesMax
    : DEFAULT_MAX;

export const favoritesStore = createIdStore({
  key: "sitepick_favorites",
  eventName: "sitepick:favorites:change",
  max,
});
